import { createAction } from 'redux-act';

import MergedTable from '../../../models/interfaces/layout/MergedTable';
import { Reservation, ReservationSeating, SeatedReservation } from '../../../models/interfaces/reservation/Reservation';
import ReservationAcceptState from '../../../models/interfaces/reservation/ReservationAcceptState';
import ReservationRejectReason from '../../../models/interfaces/reservation/ReservationRejectReason';
import TimestampPayload from '../TimestampPayload';
import ReservationPayload from './ReservationPayload';

export interface CreateReservationPayload extends ReservationPayload {
  pendingReservation: Reservation;
  seating?: ReservationSeating;
  mergedTable?: MergedTable;
}
export const createReservation = createAction<CreateReservationPayload>('CREATE_RESERVATION');

export interface ReservationCreatedPayload extends TimestampPayload, ReservationPayload {
  reservation: SeatedReservation;
  createdMergedTable: MergedTable | null;
  acceptState: ReservationAcceptState | undefined;
}
export const reservationCreated = createAction<ReservationCreatedPayload>('RESERVATION_CREATED');

export interface ReservationCreationFailedPayload extends TimestampPayload, ReservationPayload {
  placeUuid: string;
  rejectReason: ReservationRejectReason | undefined;
}
export const reservationCreationFailed = createAction<ReservationCreationFailedPayload>('RESERVATION_CREATION_FAILED');
